@if (dataSource && dataSource.data?.length) {
  <div class="container my-4">
    <div class="mat-elevation-z8 table-container-rounded">
      <div class="table-scroll-wrapper">
    <table mat-table [dataSource]="dataSource" matSort class="w-100 table-primary">
      <!-- Colonna Previous Map ID -->
      <ng-container matColumnDef="previousMap">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Previous Map ID</th>
        <td mat-cell *matCellDef="let map">
          {{ map.previous_map_id ? map.previous_map_id : '-' }}
        </td>
      </ng-container>
      <!-- Colonna Major Version -->
      <ng-container matColumnDef="version">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Version</th>
        <td mat-cell *matCellDef="let map"> {{ map.version }}</td>
      </ng-container>
      <!-- Colonna Created At -->
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Created At</th>
        <td mat-cell *matCellDef="let map"> {{ map.created_at | date:'short' }}</td>
      </ng-container>
      <!-- Colonna Major Version -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Status</th>
        <td mat-cell *matCellDef="let map">
          <mat-chip-grid>
            <mat-chip [ngClass]="getMapStatusChipClass(map.status)" class="text-white">
              {{ ("pages.ckm-simulations.status." + map.status) | translate }}
            </mat-chip>
          </mat-chip-grid>
        </td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef class="mat-column-action"> {{ 'generic.action' | translate }}</th>
        <td mat-cell *matCellDef="let element" class="mat-column-action">
          <button mat-button color="primary" type="button"
            class="ckm-map-action-btn"
            [routerLink]="['/ckm-maps/' + element.id]"
            routerLinkActive="router-link-active">
            <span class="ckm-map-action-label">{{ 'generic.buttons.go-to-ckm-map' | translate }}</span>
            <mat-icon iconPositionEnd>forward</mat-icon>
          </button>
        </td>
      </ng-container>
      <!-- Header e righe della tabella -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
      </div>
      <mat-paginator
        [pageSizeOptions]="[5, 10, 20]"
        showFirstLastButtons
        aria-label="Select page of maps">
      </mat-paginator>
    </div>
  </div>
} @else {
  <div class="no-data text-center">
    <p>Nessuna mappa disponibile.</p>
  </div>
}

